import { IComponentOptions } from "angular";
import { GamingContractEditController } from "./controller";

export const vsComponentName = "gamingContractEditComponent";

export const gamingContractEditComponentOptions: IComponentOptions = {
  controller: GamingContractEditController,
  template: require("!html-loader!./index.html").default,
  controllerAs: "stateController",
  bindings: {
    contract: "<",
    contractType: "<",
  },
};
